<template>
	<div class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3">
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text" style="min-width: 6em;">Name</span>
			</div>
			<input type="text" class="form-control" v-model="name" />
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text" style="min-width: 6em;">Maximum</span>
			</div>
			<input type="number" class="form-control" v-model.number="maxPoints" />
		</div>
	</div>
</template>

<script>
import ucFirst from "@/mixins/ucfirst.js";

function mapPoolProperties( properties ){
	var computed = {}
	properties.forEach((property) => {
		computed[property] = {
			get () {
				return this.$store.getters[`character/pools/${property}`](this.level, this.poolID)
			},
			set ( value ){
				this.$store.dispatch(`character/pools/update${this.ucFirst(property)}`,{
					level: this.level,
					id: this.poolID,
					value,
				})
			}
		}
	})
	return computed
}

export default {
	mixins: [
		ucFirst,
	],
	props: [
		'level',
		'poolID',
	],
	computed: {
		...mapPoolProperties([
			'name',
			'currentPoints',
			'maxPoints',
		])
	},
}
</script>

<style scoped>

</style>